import React from "react";
import AiSearchCard from "./AiSearchCard";

function AiSearch() {
  return (
    <>
    <div className="mt-[-220px] z-4"></div>
      <AiSearchCard />
    </>
  );
}

export default AiSearch;
